import React, { ReactNode } from 'react';

import { LinearProgress } from '@material-ui/core';

import { default as EditIcon } from '@material-ui/icons/Edit';

import { usePrivileges } from '../../../../../../../state/auth/index.hooks';

import {
    useClientDetailsLoading,
    useSelectedClientId,
} from '../../../../../../../state/ui/customerService/clientsAndLocations/index.hooks';

import { enterClientEditMode } from '../../../../../../../state/ui/customerService/bottomGrid';

import { useToolkitDispatch } from '../../../../../../../hooks';

import TranslationHelper from '../../../../../../../helpers/TranslationHelper';
import PaneHeader from '../../../../../../../components/PaneHeader';
import IconButtonWithTooltip from '../../../../../../../components/IconButtonWithTooltip';
import ClientPreviewForm from '../../ClientsAndLocations/ClientPreviewForm';
import { IServiceClient } from '../../../../../../../models/customerService';
import { useTaskPaneLoading } from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';

interface IOwnProps {
    client: IServiceClient | null;
    handleClose: () => void;
    titleComponent?: ReactNode;
}

const ClientPane = ({ client, handleClose, titleComponent }: IOwnProps) => {
    const privileges = usePrivileges();
    const clientId = useSelectedClientId();

    const clientLoading = useClientDetailsLoading();
    const paneLoading = useTaskPaneLoading();
    const toolkitDispatch = useToolkitDispatch();
    const isLoading = paneLoading || clientLoading || !location;

    const handleEdit = () => {
        toolkitDispatch(enterClientEditMode());
    };

    return (
        <>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Client')}
                titleComponent={titleComponent}
                renderRightCustomControls={() => (
                    <>
                        {privileges.manageCustomerServiceCentre && clientId && (
                            <IconButtonWithTooltip
                                title={TranslationHelper.translate('Edit')}
                                onClick={handleEdit}
                            >
                                <EditIcon />
                            </IconButtonWithTooltip>
                        )}
                    </>
                )}
            />

            {isLoading ? (
                <LinearProgress />
            ) : (
                <ClientPreviewForm initialValues={client} />
            )}
        </>
    );
};
export default ClientPane;
